module.exports = __webpack_public_path__ + "static/media/systemConfig_hoverActive.54c0d050.svg";